'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.filter('makeRange', function () {
  return function (input) {
    var lowBound, highBound;
    switch (input.length) {
      case 1:
        lowBound = 0;
        highBound = parseInt(input[0]) - 1;
        break;
      case 2:
        lowBound = parseInt(input[0]);
        highBound = parseInt(input[1]);
        break;
      default:
        return input;
    }
    var result = [];
    for (var i = lowBound; i <= highBound; i++) {
      result.push(i);
    }
    return result;
  };
});
ngModule.filter("repeat", function (stringUtils) {
  return function repeatFilter(sequence, times) {
    return stringUtils.repeatSequence(sequence, angular.isDefined(times) ? times : 1);
  };
});
ngModule.filter("join", function () {
  return function joinFilter(array, join) {
    return array.join(join || "");
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/filters/repeaters.js
// module id = 2707
// module chunks = 13